module.exports = __webpack_public_path__ + "static/img/200325.86824a3a.png";